module.exports = __webpack_public_path__ + "static/media/use-left.45f41c26.png";